module.exports = __webpack_public_path__ + "static/media/moment01.7aa3f126.webp";